import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

// Auth session is stored in a secure httpOnly cookie set by the backend,
// so the browser sends it automatically with credentials.
const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "X-Requested-With": "XMLHttpRequest" },
});

export function mediaUrl(path) {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    if (path.startsWith("/api/")) return `${BACKEND}${path}`;
    return path;
}

export function apiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
